import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { CommonService } from 'src/app/core/services/common.service';
import { NeverBounceService } from 'src/app/core/services/neverbounce.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-guest-login',
  templateUrl: './guest-login.component.html',
  styleUrls: ['./guest-login.component.scss']
})
export class GuestLoginComponent implements OnInit {
  successButtonText: string = 'Continue shopping';

  constructor(
    private fb: UntypedFormBuilder,
    private loginService: AuthenticationService,
    private commonService: CommonService,
    private router: Router,
    private nbService: NeverBounceService
  ) { }


  emailPattern: string = "^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$";
  loginForm: UntypedFormGroup
  user
  inputText: string = '';
  ngOnInit() {
    console.log(localStorage.getItem('selectTeam'));

    if (localStorage.getItem('selectTeam') == "Y"){
      this.successButtonText = 'Continue';  
    }
    else this.successButtonText = 'Continue shopping';
    this.createLoginForm()
    this.nbService.loadScript();
  }
  onBlur(event: FocusEvent): void {
    const input = event.target as HTMLInputElement;

    if (!input) {
      console.warn('⚠️ No input target found on blur.');
      return;
    }

    this.nbService.validateInput(input).catch(err => {
      console.warn('NeverBounce validation skipped:', err);
    });
  }

  onInputChange(){ 
    this.loginForm.value.email=this.inputText.toLowerCase();
    this.inputText=this.loginForm.value.email 
  }
  signUp() {
    this.router.navigateByUrl('enduser/signup' + '?isGuest=true')
  }

  createLoginForm() {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
      password: ['', Validators.required]
    })
  }

  submitEmail() {
    if (this.loginForm.get('email').valid) {
      this.loginService.validateUser(this.loginForm.value.email).subscribe(res => {
        if (res.data.isUserVerified) {
          this.router.navigateByUrl('enduser/login' + '?email=' + this.loginForm.value.email)
          window.parent.postMessage(res.data, "*");
          window.top.postMessage("cart count-" + res.data.cartTotal, "*");
        } else {
          this.user = res.data
          window.parent.postMessage(res.data, "*");
          window.top.postMessage("cart count-" + res.data.cartTotal, "*");
        }
      })
    } else {
      this.commonService.openErrorSnackBar("Please enter a valid email", "")
    }
  }

  cancelEmail() {
    Swal.fire({
      icon: 'warning',
      text: `We need an email address to create your cart`,
      cancelButtonText: 'Go back without email',
      confirmButtonText: 'Continue with email',
      showCancelButton: true,
      reverseButtons: true
    }).then(res => {
      if (!res.isConfirmed) {
        window.parent.postMessage("action - ", "*");
        this.closePopup()
      }
    })
  }

  closePopup() {
    window.parent.postMessage("close popup", "*");
    console.log("angular close popup")
  }

}
